/* vp-formulas-slider — "next" scrolls the track one page (2 images); "back" appears after the first page, "next" hides at the end. */
(function () {
  if (customElements.get('vp-formulas-slider')) return;

  class VPFormulasSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vp-fs__track');
      this.prev = this.querySelector('.vp-fs__arrow--prev');
      this.next = this.querySelector('.vp-fs__arrow--next');
      if (!this.track || !this.prev || !this.next) return;
      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update());
      this.update();
    }

    atStart() {
      return this.track.scrollLeft <= 2;
    }

    atEnd() {
      return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }

    update() {
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
      this.prev.hidden = !scrollable || this.atStart();
      this.next.hidden = !scrollable || this.atEnd();
    }

    step(dir) {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      // one page = visible width: 2 images side by side (desktop) or 2 stacked (mobile)
      this.track.scrollBy({ left: dir * (this.track.clientWidth + gap), behavior: 'smooth' });
    }
  }

  customElements.define('vp-formulas-slider', VPFormulasSlider);
})();
